import { render, staticRenderFns } from "./information-again.vue?vue&type=template&id=4f649c36&scoped=true"
import script from "./information-again.vue?vue&type=script&lang=js"
export * from "./information-again.vue?vue&type=script&lang=js"
import style0 from "./information-again.vue?vue&type=style&index=0&id=4f649c36&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f649c36",
  null
  
)

export default component.exports